import axios from "axios";
import oauth from "./oauth";

// Custom OAuth 1.0a interceptor function
function addOAuthToRequest(config) {
  const requestData = {
    url: `${config.baseURL}${config.url}`,
    method: config.method.toUpperCase(),
  };

  // Generate OAuth authorization data
  const authData = oauth.authorize(requestData);

  // Add OAuth parameters to headers
  const oauthHeader = oauth.toHeader(authData);
  config.headers = {
    ...config.headers,
    ...oauthHeader,
  };

  return config;
}

// Tạo axios instance
const request = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 30000,
  headers: {
    "X-Custom-Header": "foobar",
    // "Content-Type": "application/x-www-form-urlencoded",
    // "X-Requested-With": "XMLHttpRequest",
  },
});
// Add a request interceptor
request.interceptors.request.use(
  function (config) {
    // Add OAuth 1.0a authentication to the request
    return addOAuthToRequest(config);
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
request.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    if (error?.response?.status === 401 && typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("lianne:auth-unauthorized"));
    }

    return error.response?.data || Promise.reject(error);
  }
);

export default request;
